import { history } from 'utils';

export const detectIframeLink = (): boolean => {
  const urlParts = history.location.pathname.split('/');

  return Boolean(urlParts.find((item) => item === 'iframe'));
};
